export default __webpack_public_path__ + "static/project-slide-3-768-700-0e3cdad24b5a53c1839c84ad7d6a94d7.jpg";